export default __webpack_public_path__ + "static/media/gate-passenger.38119f53.jpg";